export const indexFingerCoverTipOut = (
  ctx: CanvasRenderingContext2D,
  leatherColor: string,
  stitchColor: string,
  x: number,
  y: number,
  numerator: number
): void => {
  ctx.lineWidth = 1.0
  ctx.fillStyle = leatherColor
  ctx.strokeStyle = '#3b3b3b'
  ctx.save()
  ctx.rotate((numerator * Math.PI) / 180)

  ctx.beginPath()

  ctx.moveTo(372 + x, 345 + y) // 左下
  ctx.quadraticCurveTo(385 + x, 278 + y, 405 + x, 220 + y) // 左上
  ctx.quadraticCurveTo(415 + x, 231 + y, 455 + x, 221 + y) // 右上
  ctx.quadraticCurveTo(436 + x, 361 + y, 436 + x, 351 + y) // 右下
  ctx.quadraticCurveTo(432 + x, 353 + y, 413 + x, 377 + y) // 切れ端部分右下
  ctx.quadraticCurveTo(375 + x, 403 + y, 362 + x, 380 + y) //
  ctx.quadraticCurveTo(363 + x, 365 + y, 372 + x, 345 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // 左縦
  // 外側
  // ctx.moveTo(404+x, 235+y) // 左下
  // ctx.quadraticCurveTo(385+x, 290+y, 381+x, 330+y) // 左上
  // 内側
  // ctx.moveTo(385+x, 310+y) // 左下
  // ctx.quadraticCurveTo(387+x, 290+y, 408+x, 235+y) // 左上

  // 右縦
  // 内側
  ctx.moveTo(447 + x, 228 + y) // 右上
  ctx.quadraticCurveTo(430 + x, 354 + y, 428 + x, 348 + y) // 右下
  // 外側
  ctx.moveTo(451 + x, 229 + y) // 右上
  ctx.quadraticCurveTo(432 + x, 356 + y, 432 + x, 347 + y) // 右下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  // stitchここまで
  ctx.restore()
}
